(function () {
  // Wait for product-info.js and media-gallery.js to initialize
  document.addEventListener('DOMContentLoaded', function () {
    initVariantGroupGallery();
  });

  function initVariantGroupGallery() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    const variantGroupScript = document.getElementById('variantGroup');
    if (!variantGroupScript) return;

    let variantGroupData;
    try {
      variantGroupData = JSON.parse(variantGroupScript.textContent);
    } catch (e) {
      console.error('variantGroup JSON parse error', e);
      return;
    }

    if (!variantGroupData?.enable || !variantGroupData?.mapping) return;

    const mediaGallery = productInfo.querySelector('media-gallery');
    if (!mediaGallery) return;

    // Build a quick lookup: variantId -> [mediaId, ...]
    const variantMediaMap = {};
    variantGroupData.mapping.forEach(function (item) {
      variantMediaMap[item.id] = item.media || [];
    });

    // Listen for Shopify variant change event (dispatched by variant-picker.js)
    productInfo.addEventListener('on:variant:change', function (e) {
      const variant = e.detail?.variant;
      if (!variant) return;
      handleVariantChange(variant, mediaGallery, variantMediaMap);
    });

    // Also handle on page load for the initially selected variant
    const selectedVariantScript = productInfo.querySelector('[data-selected-variant]');
    if (selectedVariantScript) {
      try {
        const selectedVariant = JSON.parse(selectedVariantScript.textContent);
        handleVariantChange(selectedVariant, mediaGallery, variantMediaMap);
      } catch (e) {}
    }
  }

  function handleVariantChange(variant, mediaGallery, variantMediaMap) {
    const variantId = String(variant.id);
    const mediaIds = variantMediaMap[variantId];

    if (!mediaIds || mediaIds.length === 0) return;

    const allSlides = mediaGallery.querySelectorAll(
      '.m-product-media--item:not(.swiper-slide-duplicate)'
    );

    // Hide all slides first
    allSlides.forEach(function (slide) {
      slide.style.display = 'none';
      slide.classList.add('vg-hidden');
    });

    // Show only slides matching this variant's media IDs (in order)
    const galleryList = mediaGallery.querySelector(
      '.m-media-gallery__list, .swiper-wrapper'
    );

    mediaIds.forEach(function (mediaId, index) {
      const slide = mediaGallery.querySelector(
        `.m-product-media--item[data-media-id="${mediaId}"]:not(.swiper-slide-duplicate)`
      );
      if (!slide) return;

      slide.style.display = '';
      slide.classList.remove('vg-hidden');

      // Reorder: move to correct position in the list
      if (index === 0) {
        galleryList.prepend(slide);
      } else {
        const prevSlide = mediaGallery.querySelector(
          `.m-product-media--item[data-media-id="${mediaIds[index - 1]}"]:not(.swiper-slide-duplicate)`
        );
        if (prevSlide && prevSlide.nextSibling) {
          galleryList.insertBefore(slide, prevSlide.nextSibling);
        } else {
          galleryList.appendChild(slide);
        }
      }
    });

    // Reset slider to first slide after reorder
    const sliderInstance = mediaGallery.slider;
    if (sliderInstance && typeof sliderInstance === 'object') {
      setTimeout(function () {
        sliderInstance.update();
        sliderInstance.slideTo(0, 0, false);
        if (mediaGallery.navSlider && typeof mediaGallery.navSlider === 'object') {
          mediaGallery.navSlider.update();
          mediaGallery.navSlider.slideTo(0, 0, false);
        }
      }, 50);
    }
  }
})();